
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-20173.102 -13671.634 19.627 18.902"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_5_1","data-name":"Symbol 5 – 1","transform":"translate(-20172.502 -13671.005)"}},[_c('g',{attrs:{"id":"Group_46","data-name":"Group 46","opacity":".87"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_74","d":"M1 35.059s3.777.528 5.564-.934c1.827-1.462 2.274-3.939.244-5a2.211 2.211 0 0 0-3.289 2.355A3.287 3.287 0 0 1 1 35.059z","data-name":"Path 74","transform":"translate(-1 -17.525)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_75","d":"M15.1 12.629a2.975 2.975 0 0 1 1.013-3.249c1.706-1.421 8.853-7.716 9.747-8.2a1.2 1.2 0 0 1 1.746 1.462c-.447 1.218-7.554 8.934-8.244 9.665s-1.462 1.949-3.168 1.462","data-name":"Path 75","transform":"translate(-9.291 -1.024)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_15","d":"M0 0l3.046 3.086","data-name":"Line 15","transform":"translate(6.985 8.234)"}})])])])
          )
        }
      }
    